import { useRef } from 'react'
import { Transition } from 'react-transition-group'

import LottieOrImage from '@/components/Animation/LottieOrImage'
import { useRunnerUITransition } from '@/composables/useRunnerUITransition'
import useMedia from '@/utils/hooks/useMedia'

import LoadingFooterItem from './LoadingFooterItem'

type LoadingFooterProps = {
  isVisible: boolean
  className?: string
  progress?: number
}
export default function LoadingFooter({ isVisible, className, progress }: LoadingFooterProps) {
  const elementRef = useRef<HTMLDivElement>(null)
  const { onEnter, onExit, timeout } = useRunnerUITransition(elementRef, { from: 'bottom' })
  const isReducedMotion = useMedia('(prefers-reduced-motion: reduce)')

  return (
    <Transition
      in={isVisible}
      onEnter={onEnter}
      onExit={onExit}
      unmountOnExit
      mountOnEnter
      timeout={timeout}
      nodeRef={elementRef}
    >
      <div
        ref={elementRef}
        className={`min-h-80 flex items-center justify-center gap-16 ${className ? className : ''}`}
      >
        <div className='text-body-s'>Loading</div>
        {progress !== undefined && <div className='text-body-s'>{Math.floor(progress * 100)}%</div>}
        {isReducedMotion ? null : (
          <>
            <div className='flex items-center justify-center gap-4 text-14'>
              <LoadingFooterItem index={0} delay={0} />
              <LoadingFooterItem index={1} delay={0.2} />
              <LoadingFooterItem index={2} delay={0.45} />
            </div>
            <LottieOrImage
              className='fixed -top-full -left-full pointer-events-none'
              animationData={null}
              imageUrl=''
              loop={true}
              appear={false}
              onDOMLoaded={() => {}}
            />
          </>
        )}
      </div>
    </Transition>
  )
}
